"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicHours = void 0;
const core_1 = require("@material-ui/core");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
var Day;
(function (Day) {
    Day["Monday"] = "monday";
    Day["Tuesday"] = "tuesday";
    Day["Wednesday"] = "wednesday";
    Day["Thursday"] = "thursday";
    Day["Friday"] = "friday";
    Day["Saturday"] = "saturday";
    Day["Sunday"] = "sunday";
})(Day || (Day = {}));
const dayOrder = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
};
const styles = core_1.createStyles({
    container: {
        display: "flex",
        margin: "1rem 0"
    },
    day: {
        minWidth: "50px",
        fontWeight: "bold"
    },
    hour: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    fromToDash: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "25px"
    },
    root: {
        width: "100%",
        paddingRight: "40px"
    },
    editToggle: {
        display: "flex",
        justifyContent: "flex-end"
    },
    fromTo: {
        display: "flex"
    },
    fromToEdit: {
        display: "flex",
        margin: ".5rem 0"
    }
});
const decorate = core_1.withStyles(styles);
let ClinicHoursUnstyled = class ClinicHoursUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.editHours = false;
        this.sortDayOrder = (a, b) => {
            const [keyA] = a;
            const [keyB] = b;
            return dayOrder[keyA] - dayOrder[keyB];
        };
        this.renderEditHours = () => {
            return (React.createElement("div", null, Object.entries(this.props.clinicHours)
                .sort(this.sortDayOrder)
                .map(([day, clinicHours], index) => {
                return (React.createElement("div", { key: index, className: this.props.classes.container },
                    React.createElement(core_1.Typography, { variant: "body2", className: this.props.classes.day }, this.normalizeDay(day)),
                    React.createElement("div", null,
                        React.createElement(switch_1.MaterialSwitch, { label: "Closed", value: "closed", checked: !clinicHours.open, onChange: this.props.onChangeToggle(day)("open") }),
                        React.createElement(switch_1.MaterialSwitch, { label: "Split", value: "split", checked: clinicHours.split, onChange: this.props.onChangeToggle(day)("split") })),
                    React.createElement("div", null, clinicHours.hours.map(({ from, to }, index) => (React.createElement("div", { key: index, className: this.props.classes.fromToEdit },
                        React.createElement(text_field_1.MaterialTextField, { disabled: !clinicHours.open, label: "From", onChange: this.props.onChange(day, index)("from"), value: from }),
                        React.createElement(text_field_1.MaterialTextField, { disabled: !clinicHours.open, label: "To", onChange: this.props.onChange(day, index)("to"), value: to })))))));
            })));
        };
        this.renderDisplayHours = () => {
            return (React.createElement("div", null, Object.entries(this.props.clinicHours)
                .sort(this.sortDayOrder)
                .map(([day, clinicHours], index) => {
                const { open, hours } = clinicHours;
                return (React.createElement("div", { key: index, className: this.props.classes.container },
                    React.createElement(core_1.Typography, { variant: "body2", className: this.props.classes.day }, this.normalizeDay(day)),
                    open ? (React.createElement("div", null, hours.map(({ from, to }, index) => (React.createElement("div", { key: index, className: this.props.classes.fromTo },
                        React.createElement(core_1.Typography, { variant: "body2", className: this.props.classes.hour }, from),
                        React.createElement(core_1.Typography, { variant: "body2", className: this.props.classes.fromToDash }, "-"),
                        React.createElement(core_1.Typography, { variant: "body2", className: this.props.classes.hour }, to)))))) : (React.createElement(core_1.Typography, { className: this.props.classes.hour }, "Closed"))));
            })));
        };
        this.handleEditHoursToggle = () => {
            this.editHours = !this.editHours;
        };
        this.renderClinicHours = () => {
            if (!this.props.clinicHours) {
                console.info("this.props.clinciHours", this.props.clinicHours);
                return null;
            }
            return (React.createElement("div", null,
                React.createElement("div", { className: this.props.classes.editToggle },
                    React.createElement(switch_1.MaterialSwitch, { label: "Edit hours", value: "editHours", checked: this.editHours, onChange: this.handleEditHoursToggle, disabled: this.props.isDisabled })),
                React.createElement("div", { className: "row" }, this.editHours ? this.renderEditHours() : this.renderDisplayHours())));
        };
        this.normalizeDay = (day) => {
            let normalizedDay = day;
            switch (day) {
                case Day.Monday: {
                    normalizedDay = "Mon";
                    break;
                }
                case Day.Tuesday: {
                    normalizedDay = "Tue";
                    break;
                }
                case Day.Wednesday: {
                    normalizedDay = "Wed";
                    break;
                }
                case Day.Thursday: {
                    normalizedDay = "Thu";
                    break;
                }
                case Day.Friday: {
                    normalizedDay = "Fri";
                    break;
                }
                case Day.Saturday: {
                    normalizedDay = "Sat";
                    break;
                }
                case Day.Sunday: {
                    normalizedDay = "Sun";
                    break;
                }
                default:
                    break;
            }
            return normalizedDay;
        };
    }
    render() {
        return (React.createElement("div", { className: this.props.classes.root }, this.renderClinicHours()));
    }
};
__decorate([
    mobx_1.observable
], ClinicHoursUnstyled.prototype, "editHours", void 0);
ClinicHoursUnstyled = __decorate([
    mobx_react_1.observer
], ClinicHoursUnstyled);
exports.ClinicHours = decorate(ClinicHoursUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-site/components/clinic-hours.tsx
// module id = 4022
// module chunks = 0